export enum ModalIdentifier {
	ForgotPassword = 'forgotPassword',
	ResetPassword = 'resetPassword',
	SecurityQuestions = 'securityQuestions',
}
